import * as types from '../actionTypes'

const initialState = {
  jumpDirectToPay: false,
  jumpDirectPlatform: '',
  whatif: {},
  confirm: null,
  confirmInput: null,
  rowsToShow: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.NAVIGATE_TO_PROCESS_START: {
      return {
        ...state,
        jumpDirectPlatform: '',
        jumpDirectToPay: false,
        rowsToShow: action.payload,
        confirm: null,
        confirmInput: null
      }
    }

    case types.NAVIGATE_TO_SEARCH: {
      return {
        ...state,
        whatif: {},
        rowsToShow: null
      }
    }

    case types.NAVIGATE_TO_PAYCHARGES: {
      return {
        ...state,
        jumpDirectToPay: true,
        rowsToShow: action.payload,
        jumpDirectPlatform: action.platform
      }
    }

    case types.DND_WHAT_IF : {
      return {
        ...state,
        whatif: {
          [action.payload[0].cntrNum]: action.payload
        },
        confirm: null,
        confirmInput: null
      }
    }
    case types.DND_CONFIRM : {
      return {
        ...state,
        confirm: action.payload,
        confirmInput: action.confirmInput
      }
    }

    default:
      return state
  }
}